import useTestId from '@ori/testid-generator';
import { isNonNullable } from '@ori/ts-utils';
import { ArrowRightThin } from '@ori-ui/icons';
import { ImageBox } from "./ImageBox";
import { Price } from "./Price";
import { Brand, Buttons, Description, Info, Name, Root } from "./styles";
import { PRODUCT_TILE } from "../../common";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ProductTile = function ProductTile(_ref) {
  var brandName = _ref.brandName,
    buttons = _ref.buttons,
    currentPrice = _ref.currentPrice,
    description = _ref.description,
    labels = _ref.labels,
    name = _ref.name,
    oldPrice = _ref.oldPrice,
    productCode = _ref.productCode,
    productImageUrls = _ref.productImageUrls,
    relativeUrl = _ref.relativeUrl,
    testId = _ref.testId;
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _ref2 = buttons !== null && buttons !== void 0 ? buttons : {},
    primaryButton = _ref2.primaryButton,
    secondaryButton = _ref2.secondaryButton;
  return /*#__PURE__*/_jsxs(Root, {
    "data-testid": testId !== null && testId !== void 0 ? testId : getTestId(PRODUCT_TILE),
    href: relativeUrl !== null && relativeUrl !== void 0 ? relativeUrl : undefined,
    children: [/*#__PURE__*/_jsx(ImageBox, {
      buttons: buttons,
      labels: labels,
      productCode: productCode,
      productImageUrls: productImageUrls
    }), /*#__PURE__*/_jsxs(Info, {
      children: [brandName ? /*#__PURE__*/_jsxs(Brand, {
        children: [brandName, /*#__PURE__*/_jsx(ArrowRightThin, {})]
      }) : null, name ? /*#__PURE__*/_jsx(Name, {
        children: name
      }) : null, description ? /*#__PURE__*/_jsx(Description, {
        children: description
      }) : null, /*#__PURE__*/_jsx(Price, {
        currentPrice: currentPrice,
        labels: labels,
        oldPrice: oldPrice
      }), isNonNullable(primaryButton) || isNonNullable(secondaryButton) ? /*#__PURE__*/_jsxs(Buttons, {
        children: [primaryButton !== null && primaryButton !== void 0 ? primaryButton : null, secondaryButton !== null && secondaryButton !== void 0 ? secondaryButton : null]
      }) : null]
    })]
  });
};
//# sourceMappingURL=ProductTile.js.map